
<a v-if='blank' class='btn' :href='link' target='_blank'>{{ title }}</a>
<a v-else class='btn' :href='link'>{{ title }}</a>
